export default __webpack_public_path__ + "static/media/mini-8.a4cba197.jpg";